<!--suppress JSUnresolvedVariable -->
<template>
  <div>
    <div class="mt-4 ml-1">
      <el-row>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
            >管理中心</el-breadcrumb-item
          >
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/admin/user/role' }"
            >角色列表</el-breadcrumb-item
          >
          <el-breadcrumb-item
            ><span class="text-primary">编辑角色信息</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </el-row>
      <el-card class="my-4 mx-1">
        <div slot="header">
          <span class="font-weight-bold text-primary">编辑角色信息</span>
        </div>
        <el-form
          label-width="120px"
          class="font-weight-bold w-50"
          :model="roleInfo"
        >
          <el-form-item label="中文名称">
            <el-input v-model="roleInfo.nameZh"></el-input>
          </el-form-item>
          <el-form-item label="英文名称">
            <el-input v-model="roleInfo.name"></el-input>
          </el-form-item>
          <el-form-item label="角色描述">
            <el-input v-model="roleInfo.roleDesc"></el-input>
          </el-form-item>

          <el-form-item label="菜单配置" prop="menus">
            <el-tree
              :data="menus"
              :props="menusProps"
              show-checkbox
              :default-checked-keys="selectedMenusIds"
              :default-expanded-keys="selectedMenusIds"
              node-key="menuId"
              ref="menuTree"
            >
            </el-tree>
          </el-form-item>

          <el-form-item label="功能配置" prop="perms">
            <el-tree
              :data="perms"
              :props="permsProps"
              show-checkbox
              :default-expanded-keys="selectedPermsIds"
              :default-checked-keys="selectedPermsIds"
              node-key="permissionId"
              ref="permTree"
            >
            </el-tree>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitRoleForm(roleInfo)"
              >立即提交</el-button
            >
            <el-button @click="findRoleById()">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditRole",
  data() {
    return {
      roleId: this.$route.params.roleId,
      roleInfo: {},
      perms: [],
      menus: [],
      selectedPermsIds: [],
      selectedMenusIds: [],
      menusProps: {
        id: "menuId",
        label: "nameZh",
        children: "children"
      },
      permsProps: {
        id: "permissionId",
        label: "permissionDesc",
        children: "children"
      }
    };
  },
  mounted() {
    this.findRoleById();
    this.listPerms();
    this.listMenus();
  },
  methods: {
    findRoleById() {
      this.axios
        .get("/adminRole/findRoleById", {
          params: {
            roleId: this.roleId
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.roleInfo = resp.data.data;

            let permIds = [];
            for (let i = 0; i < resp.data.data.perms.length; i++) {
              for (
                let j = 0;
                j < resp.data.data.perms[i].children.length;
                j++
              ) {
                permIds.push(resp.data.data.perms[i].children[j].permissionId);
              }
            }
            this.selectedPermsIds = permIds;
            if (this.$refs.permTree) {
              this.$refs.permTree.setCheckedKeys(permIds);
            }
            let menuIds = [];
            for (let i = 0; i < resp.data.data.menus.length; i++) {
              for (
                let j = 0;
                j < resp.data.data.menus[i].children.length;
                j++
              ) {
                menuIds.push(resp.data.data.menus[i].children[j].menuId);
              }
            }
            this.selectedMenusIds = menuIds;
            // 判断树是否已经加载，第一次打开对话框前树不存在，会报错。所以需要设置 default-checked
            if (this.$refs.menuTree) {
              this.$refs.menuTree.setCheckedKeys(menuIds);
            }
          }
        });
    },
    listPerms() {
      this.axios.get("/adminPermission/listAllPermissions").then(resp => {
        if (resp && resp.data.code === 10000 && resp.data.success) {
          this.perms = resp.data.data;
        }
      });
    },
    listMenus() {
      this.axios.get("/adminMenu/listAllMenus").then(resp => {
        if (resp && resp.data.code === 10000 && resp.data.success) {
          this.menus = resp.data.data;
        }
      });
    },
    submitRoleForm(roleInfo) {
      this.axios
        .post("/adminRole/admin/EditRole", {
          roleId: roleInfo.roleId,
          name: roleInfo.name,
          nameZh: roleInfo.nameZh,
          roleDesc: roleInfo.roleDesc,
          menus: this.$refs.menuTree
            .getCheckedKeys()
            .concat(this.$refs.menuTree.getHalfCheckedKeys()),
          perms: this.$refs.permTree
            .getCheckedKeys()
            .concat(this.$refs.permTree.getHalfCheckedKeys())
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$notify({
              title: "成功",
              message: resp.data.message,
              type: "success"
            });
            // 修改角色后返回角色列表界面
            this.$router.push({ name: "Role" }).catch();
          } else {
            this.$notify.error({
              title: "错误",
              message: resp.data.message
            });
          }
        });
    }
  }
};
</script>

<style scoped></style>
